// Apply-mode skip reasons of the API's getApplyRequireRows, their Hebrew labels, and the empty-state decision.
// Pure, so the checks execute the real logic.

export const QUEUE_OVERFLOW_TEXT = 'תור הבקשות לטרנזילה מלא כרגע. נסו שוב מאוחר יותר.'

export const SKIPPED_REASON_LABELS: { [key: string]: string } = {
    classify_failed: 'טרנזילה לא זמינה',
    overwrite_failed: 'שגיאת עדכון',
    not_applyable: 'חיוב לא נמצא / לא ניתן לביצוע',
    rate_limited: 'טרנזילה חסמה זמנית בקשות',
    tranzila_unavailable: 'טרנזילה לא זמינה',
    // a per-record transaction-report failure (TRANZILA_REPORT_INVALID / TRANZILA_TRANSACTION_REPORT_ERROR)
    // the API's own request queue to Tranzila was full (nothing was sent): not an outage, not a rate limit
    tranzila_queue_overflow: QUEUE_OVERFLOW_TEXT,
    tranzila_report_failed: 'לא ניתן לקבל דוח עסקאות מטרנזילה. נדרשת בדיקה ידנית.',
    moved_to_handle: 'הועבר לטיפול — לא נמצא חיוב פעיל'
}

export interface EmptyResultsDecision {
    message: string
    type: 'info' | 'warning'
}

// What to say when the apply run produced no rows. Only rate_limited / tranzila_unavailable skips mean
// "Tranzila is unavailable, try again later"; a report failure (or any other reason) never does.
export const emptyResultsDecision = (
    applyMode: boolean,
    applySkipped: Array<{ reason?: string }>
): EmptyResultsDecision => {
    if (!applyMode) {
        return { message: 'הקובץ עובד — אין רשומות לביצוע. ניתן לבדוק את הרשומות ברשימה', type: 'info' }
    }
    if (applySkipped.length === 0) return { message: 'אין רשומות לביצוע', type: 'info' }
    if (applySkipped.every(item => item.reason === 'moved_to_handle')) {
        return { message: 'לא נמצאו רשומות לביצוע — הרשומות הועברו לטיפול', type: 'info' }
    }
    if (applySkipped.some(item => item.reason === 'rate_limited' || item.reason === 'tranzila_unavailable')) {
        return { message: 'לא נמצאו רשומות לביצוע — טרנזילה אינה זמינה כרגע, נסו שוב מאוחר יותר', type: 'warning' }
    }
    // a full local queue stopped the run: the approved sentence, never the "Tranzila unavailable" banner
    if (applySkipped.some(item => item.reason === 'tranzila_queue_overflow')) {
        return { message: QUEUE_OVERFLOW_TEXT, type: 'warning' }
    }
    return { message: 'לא נמצאו רשומות לביצוע — ראו פירוט להלן', type: 'warning' }
}
